import {
  CLOSE_ON_ANCESTOR_SCROLL_ALWAYS,
  CLOSE_ON_ANCESTOR_SCROLL_USER,
} from '../../constants/select'

// Space of the roomier vertical side (above / below the reference), px
function getMaxVerticalSpace(referenceElement, gap) {
  const { bottom, top } = referenceElement.getBoundingClientRect()

  return Math.max(top, window.innerHeight - bottom) - gap
}

export function isCloseOnAncestorScrollUser(value) {
  return value === CLOSE_ON_ANCESTOR_SCROLL_USER
}

export function isCloseOnAncestorScrollAlways(value) {
  return value === CLOSE_ON_ANCESTOR_SCROLL_ALWAYS
}

// Clamp by the roomier side instead of the current placement: a
// placement-dependent height always "fits", so `flip` would never move the
// dropdown to the side with more space, and `autoUpdate` would bounce between
// placements (ResizeObserver loop)
export function getAvailableSideHeight({
  availableHeight,
  gap,
  referenceElement,
}) {
  return Math.max(availableHeight, getMaxVerticalSpace(referenceElement, gap))
}
